<script lang="ts" setup>
import { useTranslation } from '@hfc/ui-core';

const { t } = useTranslation();
</script>

<template>
  <div class="md:px-12">
    <h4 class="text-blue text-xl font-bold pb-6 md:pb-10">{{ t('coveredCalifornia.questions.enrollOutside.tab') }}</h4>
    <p class="text-gray-500 text-left pb-4">{{ t('coveredCalifornia.questions.enrollOutside.p1') }}</p>
    <ul class="text-gray-500 text-left list-disc pl-5 space-y-2">
      <li v-html="t('coveredCalifornia.questions.enrollOutside.item1')"></li>
      <li v-html="t('coveredCalifornia.questions.enrollOutside.item2')"></li>
      <li v-html="t('coveredCalifornia.questions.enrollOutside.item3')"></li>
    </ul>
  </div>
</template>
